/* eslint-disable radix */
import React, { FunctionComponent } from 'react';
import {
  Container,
  Grid,
  GridItem,
  Select,
  Box,
  Text,
  Flex,
} from '@chakra-ui/react';
import { Job, Office, Department, IPropsJobList } from '../../types/jobsTypes';
import JobListingHeader from './JobListingHeader';
import JobListingItem from './JobListItem';

export const ALL_OFFICES = 'all locations';
export const ALL_TEAMS = 'all teams';

const filterJobs = (
  allJobs: Job[],
  selectedOffice: string,
  selectedDepartment: string,
) =>
  allJobs.filter(({ office, department }) => {
    const officeFilter =
      selectedOffice === ALL_OFFICES ? true : office === selectedOffice;
    const departmentFilter =
      selectedDepartment === ALL_TEAMS
        ? true
        : department === selectedDepartment;

    return officeFilter && departmentFilter;
  });

const JobsList: FunctionComponent<IPropsJobList> = ({
  allJobs,
  allOffices,
  allDepartments,
  selectedOffice,
  selectedDepartment,
  setOffice,
  setDepartment,
}) => {
  const filteredJobs = filterJobs(allJobs, selectedOffice, selectedDepartment);

  return (
    <Container id="open-roles" py="24" maxW="container.xl">
      <JobListingHeader />
      <Grid
        mx="auto"
        maxW="720px"
        templateColumns={['repeat(1, 1fr)', 'repeat(2, 1fr)']}
        columnGap="6"
        rowGap="6"
      >
        <GridItem colSpan={1}>
          <Select
            height="14"
            borderWidth="2px"
            borderStyle="solid"
            borderColor="hoverBlue"
            fontSize="lg"
            fontWeight="medium"
            value={selectedDepartment}
            onChange={({ target: { value } }) => setDepartment(value)}
          >
            <option value={ALL_TEAMS}>All Teams</option>
            {allDepartments.map(({ name }: Department) => (
              <option key={name} value={name}>
                {name}
              </option>
            ))}
          </Select>
        </GridItem>

        <GridItem colSpan={1}>
          <Select
            height="14"
            borderWidth="2px"
            borderStyle="solid"
            borderColor="hoverBlue"
            fontSize="lg"
            fontWeight="medium"
            value={selectedOffice}
            onChange={({ target: { value } }) => setOffice(value)}
          >
            <option value={ALL_OFFICES}>Locations</option>
            {allOffices.map(({ name }: Office) => (
              <option key={name} value={name}>
                {name}
              </option>
            ))}
          </Select>
        </GridItem>
      </Grid>

      <Box pt="6">
        <Flex justifyContent="center" textAlign="center">
          <Text fontSize="lg">
            <Text as="span" fontWeight="bold">
              {filteredJobs.length}
            </Text>{' '}
            roles across{' '}
            <Text as="span" fontWeight="bold">
              {selectedDepartment}
            </Text>{' '}
            and{' '}
            <Text as="span" fontWeight="bold">
              {selectedOffice}
            </Text>
          </Text>
        </Flex>
      </Box>

      <Box py="12">
        {filteredJobs.map((job: Job) => (
          <JobListingItem
            key={job.id}
            jobId={job.id}
            title={job.title}
            office={job.office}
            department={job.department}
          />
        ))}
      </Box>
    </Container>
  );
};

export default JobsList;
